import type { Section } from '@common/formEngine/formEngine.types';
import type { HolterExaminationRequest } from './hollterRequestsSchemas';
import type { HolterExaminationRequestContentKeys } from './holterExaminationRequestSchemas';
import type { HolterExaminationRequestAdvice, HolterExaminationRequestBase, HolterReferralData } from './utils/utils';
import {
    holterAnamnesisSection,
    holterHistorySection,
    holterRustEcgSection,
    medicationSection,
} from './hollterRequestsSchemas';
import { type HolterConfigureData, holterConfigureSections } from './holterConfigureSchemas';
import {
    adviceSection,
    diagnosisSection,
    holterRiskFactorsSection,
    holterSetupSection,
    professionalSummarySection,
    referralSectionBaseFields,
} from './holterExaminationRequestSchemas';

export type HolterDirectExaminationRequestData = HolterExaminationRequestBase &
    HolterReferralData &
    HolterExaminationRequestAdvice &
    HolterConfigureData;

export const referralSection: Section<HolterReferralData, undefined, HolterExaminationRequest> = {
    fields: [...referralSectionBaseFields],
    title: 'Verwijzing',
};

export const holterDirectExaminationRequestSections: Section<
    HolterDirectExaminationRequestData,
    HolterExaminationRequestContentKeys,
    HolterExaminationRequest
>[] = [
    referralSection,
    holterSetupSection,
    holterAnamnesisSection,
    holterRustEcgSection,
    holterHistorySection,
    medicationSection,
    adviceSection,
    holterRiskFactorsSection,
    professionalSummarySection,
    diagnosisSection,
    ...holterConfigureSections,
];
